import { render } from "./HeroiconsOutlineShieldExclamation.vue?vue&type=template&id=62e7a19c"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShieldExclamation.vue"]])

export default __exports__